import { Dialog } from "primereact/dialog";
import { Tag } from "primereact/tag";
import { Divider } from "primereact/divider";
import Button from "../../componentes/button/button";
import { useState } from "react";

export default function VeiculoViewModal({ visible, onHide, veiculo }) {
  const [modalDesenho, setModalDesenho] = useState(false);

  const closeModalDesenho = () => {
    setModalDesenho(false);
  }

  if (!veiculo) return null;

  const footer = <div className="flex pt-3 justify-end gap-2 border-top border-border">
    <Button
      onClick={onHide}
      label="Fechar"
      color="gray-200"
      textColor="dark"
      iconLeft="fa fa-times"
    />
  </div>

  return (
    <Dialog
      header="Detalhes do Veículo"
      visible={visible}
      onHide={onHide}
      modal
      footer={footer}
      blockScroll
      className="p-fluid w-[90%]"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-8 pt-1">

        <Card title="Informações Básicas" icon="fa fa-exclamation-circle">
          <Item label="Placa" value={veiculo.placa} />
          <Item label="Código da York" value={veiculo.codigoYork} />
          <Item label="Código da Solar" value={veiculo.codigoSolar} />
        </Card>

        <div className="md:col-span-2">
          <Card title="Localização" icon="fa fa-line-chart">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Item label="Status">
                <Tag
                  value={veiculo.ativo ? 'Ativo' : 'Inativo'}
                  severity={veiculo.ativo ? 'success' : 'danger'}
                />
              </Item>
        
            </div>
          </Card>
        </div>

      </div>

      <Divider />

      <Dialog
        onHide={closeModalDesenho}
        visible={modalDesenho}
        className="w-[97%]"
      >

      </Dialog>



    </Dialog>
  );
}
function Card({ title, children, icon }) {
  return (
    <div className="bg-muted p-4 rounded-lg border border-border">
      <h3 className="text-lg font-semibold text-foreground mb-3 flex items-center">
        <i className={icon + " mr-2 text-primary"}></i>
        {title}
      </h3>
      <div className="space-y-3">
        {children}
      </div>
    </div>
  );
}

function Item({ label, value, suffix, children }) {
  return (
    <div>
      <p className="text-sm text-muted-foreground">{label}</p>
      <p className="text-sm font-semibold text-foreground">
        {children ?? (value ?? '-')}{suffix && ` ${suffix}`}
      </p>
    </div>
  );
}